<template>
  <div>
    <v-data-table :headers="headers" :items="formattedBookings" :items-per-page="10">
      <template v-slot:item.actions="{ item }">
        <confirmation
          v-if="item.channel.internal === true || (item.channel.internal === false && unit.syncing === false)"
          :title="$t('page-unit-manual-booking.actions.delete-booking.confirmation-header')"
          :submitHandler="deleteSubmitHandler"
          :entity="item"
        >
          <template v-slot:activator="props">
            <v-btn color="red lighten-1" small dark @click.stop="props.showDialog">
              <v-icon left small>mdi-delete</v-icon>{{ $t('global-terms.delete') }}
            </v-btn>
          </template>
          <template v-slot:body>
            <p>{{$t('page-unit-manual-booking.actions.delete-booking.confirmation-body')}}</p>
          </template>
        </confirmation>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'pinia'
import Confirmation from '@/components/dialogs/Confirmation'
import { useBookingStore } from '@/stores'
import { clone } from 'ramda'

export default {
  name: 'booking-other-channels-table',
  data () {
    return {
      headers: [
        { width: 300, sortable: false, text: this.$t('page-unit-manual-booking.section-make-dates-unavailable.fields.channel.label'), value: 'channel.name' },
        { sortable: false, text: this.$t('page-unit-manual-booking.section-make-dates-unavailable.fields.from-date.label') + ' - ' + this.$t('page-unit-manual-booking.section-make-dates-unavailable.fields.to-date.label'), value: 'from-to-dates' },
        { sortable: false, align: 'end', value: 'actions' },
      ],
    }
  },
  props: {
    bookings: {
      type: Array,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedBookings () {
      return this.bookings.map(booking => {
        booking['from-to-dates'] = moment(booking.dates.start).format('DD/MM/Y') + ' - ' + moment(booking.dates.end).format('DD/MM/Y')
        return booking
      })
    },
  },
  methods: {
    clone,
    ...mapActions(useBookingStore, ['httpDeleteBooking']),
    deleteSubmitHandler (booking) {
      const cloneUnit = this.clone(this.unit)
      return this.httpDeleteBooking({ booking, unit: cloneUnit })
    },
  },
  components: {
    Confirmation,
  },
}
</script>
